<template>
  <div class="checkbox">
      <input
        :id="message.id"
        type="checkbox"
        @click.prevent.stop="null"
        :checked="messages_selection.index[message.id]"
        tabindex="-1"
      >
      <label
        @click='onMessageSelect($event, message)'
        :for="message.id"
      >
      </label>
  </div>
</template>

<script setup>
  import {defineEmits, defineProps} from 'vue';

  const props = defineProps({
    message_index : Number,
    message           : {},
    messages_selection: {},
  });

  const emit = defineEmits([
    'messageSelect', 'messageChange'
  ])

  const onMessageSelect = ($event, message) => {
    emit('messageSelect', $event, message);
    emit('messageChange', $event, {message: props.message, message_index: props.message_index})
  }

</script>